export enum AssetType {
    TEXTURE = 'texture',
    LAYOUT = 'layout',
    VIDEO = 'video',
    SPINE = 'spine',
    XML = 'xml',
    WEB_FONT = 'webfont',
    BITMAP_FONT = 'bitmapfont'
}
